export const DSN =
  "https://1855e3e2b2835ecbc0db1a22abbe0085@o4508863642402816.ingest.de.sentry.io/4508863674318928";

export const TRACES_SAMPLE_RATE = 1.0;
